export enum ReportType {
    Basic = "Basic",
    Extended = "Extended",
}

export enum SearchCommissionPaymentDatesSortBy {
    PaymentDate = "paymentDate",
}

export enum SearchCommissionHierarchyBalanceSortBy {
    AgentID = "agentID",
    AgentName = "agentName",
}

export enum CommissionReportSummaryColumnNameHeader {
    Description = "description",
    CumulWeekly = "cumulWeekly",
    CumulYearly = "cumulYearly",
}

export enum CommissionReportsSearchConstants {
    NumberOfResultsPerPage = 10,
    NumberOfPreviousReport = 5,
    NumberOfYearsSearchPeriod = 5,
    MaxTotalHierarchyForDefaultCollapse = 5,
}

export enum CommissionAccountStatementsSearchConstants {
    maxDateRange = 5,
    maxItemCount = 50,
}

export enum CommissionStatementDetailsTableHeader {
    PolicyNumber = "policyNumber",
    InsuredName = "insuredName",
    BaseAmount = "baseAmount",
    SplitPercentage = "splitPercentage",
    CommissionRate = "commissionRate",
    PayableMovementType = "payableMovementType",
    BonusRate = "bonusRate",
    NetCommissionAmount = "netCommissionAmount",
    TaxWithholding = "taxWithholding",
    Coverage = "coverage",
    GrossAmount = "grossAmount",
}

export enum CommissionAccountStatementTableHeader {
    Date = "date",
    Debit = "debit",
    Credit = "credit",
    Balance = "balance",
    Transaction = "transaction",
    Transfer = "transfer",
}

export enum BonusSearchElementConstants {
    MaxYearRange = 5,
    MaxAgentNumber = 4,
}

export enum MyCommissionReportSummaryColumnNameHeader {
    Description = "description",
    Cumul = "cumul",
}

export class CommissionsConstants {
    public static PieWidgetMonthsPeriod = 12;
    public static TopPerformingWidgetMonthsPeriod = 12;
    public static CommissionColumnWidgetMonthsPeriod = 12;
    public static CommissionColumnWidgetDisplayDateFormat = "MMM YY";
    public static TopPerformersMaxResults = 3;
    public static LastReportsWeekPeriod = 2;
    public static LastReportNumber = 2;
}

export enum CsvDocumentKeys {
    AccountStatement = "accountStatementCSVKey",
    ApplicationSearch = "applicationSearchCSVKey",
    CommissionReport = "commissionReportCSVKey",
    PolicySearch = "policySearchCSVKey",
}

export enum PdfDocumentKeys {
    CaseInAnalysis = "caseInAnalysisPDFKey",
}

export enum SearchCommissionStatementByContractsSortBy {
    EndBalanceDate = "endBalanceDate",
    ContractNumber = "agentContractNumber",
    AgentId = "agentID",
    TotalCommission = "paidAmount",
    AgentName = "agentName",
    TotalAmount = "netPayableAmount",
}
export enum CommissionReportsByContractsColumnNameHeader {
    EndBalanceDate = "endBalanceDate",
    AgentName = "agentName",
    TotalCommission = "paidAmount",
    TotalAmount = "netPayableAmount",
    ContractNumber = "agentContractNumber",
    AgentId = "agentID",
}

export enum AgentRecognitionBonusSortBy {
    IssueDate = "issueDate",
    PolicyNumber = "policyNumber",
    PlanName = "ProductShortName",
    AnnualPremiumAmount = "annualPremiumAmount",
    ProductionBonusPoints = "productionBonusPoints",
    SplitPercentage = "splitPercentage",
    Insured = "insured",
    BonusPercentage = "bonusPercentage",
}

export enum RecognitionBonusReportColumnNameHeader {
    IssueDate = "issueDate",
    PolicyNumber = "policyNumber",
    PlanName = "ProductShortName",
    AnnualPremiumAmount = "annualPremiumAmount",
    ProductionBonusPoints = "productionBonusPoints",
    SplitPercentage = "splitPercentage",
    Insured = "insured",
    BonusPercentage = "bonusPercentage",
}

export enum RecognitionBonusPointsTableColumnNameHeader {
    Qualification = "qualification",
    BonusPoints = "bonusPoints",
    CreditedPercent = "creditedPercent",
    BonusAmount = "bonusAmount",
}

export const RecognitionBonusReportConstants = {
    PercentagePrecision: 2,
    BonusPointsPercision: 2,
};

export enum CommissionDocumentsSortBy {
    PublicationDate = "publicationDate",
    Name = "name",
    Type = "type",
}

export const defaultCommissionConfig: CommissionssDefinition = {
    otherReports: {
        numberOfResultsPerPage: 10,
        showType: true,
    },
};

export enum CommissionDocumentsTableHeader {
    PublicationDate = "publicationDate",
    Name = "name",
    Type = "type",
    Download = "download",
}

export enum PeriodType {
    All = "ALL",
    Last30Days = "LAST_30_DAYS",
    Last60Days = "LAST_60_DAYS",
    LastYear = "LAST_YEAR",
    Last2Years = "LAST_2_YEARS",
}
